import Vue from 'vue';
import Vuex from 'vuex';

import { VoucherStore as voucher } from './voucher.store';
import { UserDataStore as userdata } from './userdata.store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    voucher,
    userdata
  },
});
